import { useEffect } from 'react'
import { getEnv } from '@/utils/helpers'
import './freshwork.css'

type FreshworkWidgetProps = {
  customer: {
    email: string
    name: string
  }
  language: string
}

export function FreshworkWidget(props: FreshworkWidgetProps) {
  const { customer, language } = props

  useEffect(() => {
    const script = document.createElement('script')
    script.src = `https://euc-widget.freshworks.com/widgets/${getEnv('VITE_FRESHWORK') || '103000003151'}.js`
    script.defer = true
    script.async = true
    script.type = 'text/javascript'
    const callback = () => {
      if ('function' === typeof window.FreshworksWidget) {
        window.FreshworksWidget('identify', 'ticketForm', {
          name: customer.name,
          email: customer.email,
        })
        window.FreshworksWidget('setLabels', {
          // TODO: Support other languages
          en: {
            contact_form: {
              form_title: 'Contact us',
              form_button_text: 'Send',
              form_submit_message: 'Your request has been taken into account!',
            },
            message: 'Welcome to Promotal MedConnect Support',
          },
        })
      }
    }
    script.onload = () => {
      setTimeout(() => {
        callback()
      }, 1000)
    }
    document.body.appendChild(script)
    window.fwSettings = {
      widget_id: getEnv('VITE_FRESHWORK') || '103000003151',
      locale: language,
    }
    if ('function' !== typeof window.FreshworksWidget) {
      window.FreshworksWidget = function () {
        ;(window.FreshworksWidget.q = window.FreshworksWidget.q || []).push(arguments)
      }
    }
  }, [customer, language])

  // RGAA 2.1: Add title to third-party iframes injected by Freshworks
  useEffect(() => {
    const observer = new MutationObserver(() => {
      document.querySelectorAll('iframe:not([title])').forEach((iframe) => {
        const src = iframe.getAttribute('src') || ''
        if (src.includes('freshworks') || iframe.id?.includes('freshworks') || iframe.id?.includes('launcher')) {
          iframe.setAttribute('title', 'Freshworks support widget')
        }
      })
    })
    observer.observe(document.body, { childList: true, subtree: true })
    return () => observer.disconnect()
  }, [])

  useEffect(() => {
    return () => {
      if (typeof window.FreshworksWidget !== 'function') return

      window.FreshworksWidget('destroy')
    }
  }, [])

  return <></>
}
